import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import Layout from '@components/Layout';
import { db } from '@root/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { toast } from 'react-hot-toast';

function FAQ() {
  const { globalUser } = useAuth();
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const q = query(collection(db, 'faqs'), orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        const faqs = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFaqData(faqs);
      } catch (error) {
        toast.error('Error fetching FAQs');
        console.error(error);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <Layout>
      <div className='row'>
        <div className='col-xl-12'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Frequently Asked Questions</h4>
              <p className='card-title-desc'>
                Click the accordions below to expand/collapse the content.
              </p>
            </div>

            <div className='card-body'>
              <div
                className='accordion accordion-primary'
                id='accordionExample'
              >
                {faqData.map((item, index) => (
                  <div className='accordion-item' key={item.id}>
                    {/* Trigger — keep as DIV, just add "collapsed" and proper ARIA */}
                    <div
                      className='accordion-header rounded-lg collapsed'
                      id={`heading${item.id}`}
                      data-bs-toggle='collapse'
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded='false'
                      aria-controls={`collapse${item.id}`}
                      role='button'
                    >
                      <span className='accordion-header-icon'></span>
                      <span className='accordion-header-text'>
                        {index + 1}. {item.question}
                      </span>
                      <span className='accordion-header-indicator'></span>
                    </div>

                    {/* Panel — remove "show" so it starts closed; keep data-bs-parent */}
                    <div
                      id={`collapse${item.id}`}
                      className='collapse'
                      aria-labelledby={`heading${item.id}`}
                      data-bs-parent='#accordionExample'
                    >
                      <div
                        className='accordion-body-text'
                        // Render HTML safely (ensure content is trusted/sanitized upstream)
                        dangerouslySetInnerHTML={{ __html: item.answer || '' }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default FAQ;
